import { RestaurantEvent } from '@shared/types/restaurants';
import { groupBy } from 'lodash-es';

type GroupedByActiveVerusExpired = {
  active: Record<string, RestaurantEvent[]>;
  expired: Record<string, RestaurantEvent[]>;
};

export const partitionByActiveInactiveGroupedByDate = (
  restaurantEvents: RestaurantEvent[],
  todayString: string,
  groupByStartTime = false,
): GroupedByActiveVerusExpired => {
  const activeEvents: RestaurantEvent[] = [];
  const expiredEvents: RestaurantEvent[] = [];

  restaurantEvents.forEach((restaurantEvent) => {
    const hasDatePassed = restaurantEvent.shift.startDate < todayString;

    if (hasDatePassed || restaurantEvent.isDeleted) {
      expiredEvents.push(restaurantEvent);
    } else {
      activeEvents.push(restaurantEvent);
    }
  });

  const key = (e: RestaurantEvent) =>
    groupByStartTime
      ? `${e.shift.startDate}_${e.shift.startTime ?? ''}`
      : e.shift.startDate;

  return {
    active: groupBy(activeEvents, key),
    expired: groupBy(expiredEvents, key),
  };
};
